module.exports = __webpack_public_path__ + "img/sw-logo.5d2a8176.svg";